import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import "./index.css";

import { store } from "./redux/store";
import { Provider } from "react-redux";
import { isNightMode } from "./helpers/generic";
import router from "./router";
import { registerAuthEventHandler } from "./auth/authEvents";
import { sessionExpired, updateIsVerified } from "./redux/slices/Auth";
import { AuthBootstrap } from "./auth/AuthBootstrap";
import { ThemeProvider } from "@mui/material";
import theme from "./theme/theme";

const body = document.getElementById("body");
if (isNightMode() && body) {
  body.style.backgroundColor = "#2b2b2b";
  body.style.color = "white";
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

registerAuthEventHandler((event) => {
  if (event === "session-expired") store.dispatch(sessionExpired());
  if (event === "verification-required") {
    store.dispatch(updateIsVerified(false));
  }
});

const renderApp = () => {
  root.render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <AuthBootstrap>
            <RouterProvider router={router} />
          </AuthBootstrap>
        </Provider>
      </ThemeProvider>
    </React.StrictMode>
  );
};

renderApp();
